








































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { BaseSheet, Sheet, SheetActivity, Examinee } from "../../modules/teacher/SheetUpload"


export interface Data {
  sheet_id: string
  score_positions_completed: boolean
  baseSheet: BaseSheet
  sheet: Sheet
  examinees: Examinee[]
  currentExaminee: Examinee | null
  currentSheetActivity: SheetActivity | null
  currentExamineeIdx: number
  currentSheetActivityIdx: number
  errors: string[]
  meiboErrors: string[]
  scale: number
  rotates: number[]
  file: any
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalSheetUploadRef = ref<InstanceType<typeof BModal>>();


    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      sheet_id: "",
      score_positions_completed: true,
      baseSheet: null,
      sheet: null,
      examinees: [],
      currentExaminee: null,
      currentSheetActivity: null,
      currentExamineeIdx: 0,
      currentSheetActivityIdx: 0,
      errors: [],
      meiboErrors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      file: null,
    });


    /******************************
     * computed
     ******************************/

    // imgタグのスタイル
    const imageStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        style["width"] = `${sheetActivitiy.baseWidth * state.scale}px`;
        style["height"] = `${sheetActivitiy.baseHeight * state.scale}px`;
        style["transform"] = `rotate(${sheetActivitiy.angle}deg)`;
        
        // 回転の中心軸設定
        let translateX: string = "";
        let translateY: string = "";
        if(sheetActivitiy.angle == 90){
          translateX = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
        }else if(sheetActivitiy.angle == 180){
          translateX = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
        }else if(sheetActivitiy.angle == 270){
          translateX = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
        }
        style["transform-origin"]  = `${translateX} ${translateY}`;
      }
      
      return style;
    });

    // imgの親divのスタイル
    const imageWrapStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        if(sheetActivitiy.angle == 0 || sheetActivitiy.angle == 180){
          style["height"] = `${(sheetActivitiy.baseHeight * state.scale) + 30}px`;
        }else{
          style["height"] = `${(sheetActivitiy.baseWidth * state.scale) + 30}px`;
        }
      }
      return style;
    });


    /******************************
     * methods
     ******************************/

    // 選択答案情報切り替え
    const changeCurrent = async (examineeIdx: number, sheetActivityIdx: number) => {
      state.currentExaminee = state.examinees[examineeIdx];
      state.currentSheetActivity = state.currentExaminee.sheetActivities[sheetActivityIdx];
      state.currentExamineeIdx = examineeIdx;
      state.currentSheetActivityIdx = sheetActivityIdx;
      state.currentSheetActivity.angle = 0;

      // 画像がキャッシュされていない場合はAPIでダウンロード
      if(state.currentSheetActivity.base64Image == null){
        const param: object = {
          sheet_id: state.sheet_id,
          sheet_activity_id: state.currentSheetActivity.id,
          page: state.currentSheetActivityIdx + 1,
          student_no: state.currentExaminee.student_no
        };
        await http.get(`/api/sheet_upload/download_image?${Common.BuildQuery(param, "")}`).then(response => {
          state.currentSheetActivity.base64Image = response.data.base64_image;
          state.currentSheetActivity.baseWidth = response.data.image_size_hash["width"];
          state.currentSheetActivity.baseHeight = response.data.image_size_hash["height"];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }
    };

    // 拡大ボタン押下
    const scaleUp = () => {
      state.scale += 0.05;
    };

    // 縮小ボタン押下
    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    };

    // 画像を表示エリアの横幅に合わせる
    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        state.scale = imageAreaW / state.currentSheetActivity.baseWidth;
      }
    };

    // 画面サイズに合わせてレイアウト整形
    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop) + "px";
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    // 前へボタン押下
    const prevCurrent = () => {
      if(state.currentSheetActivityIdx > 0){
        changeCurrent(state.currentExamineeIdx, state.currentSheetActivityIdx -1);
      }else{
        for(var i = state.currentExamineeIdx - 1; i >= 0; i--){
          if(state.examinees[i].sheetActivities != null && state.examinees[i].sheetActivities.length > 0){
            changeCurrent(i, state.baseSheet.page_count - 1);
            break;
          }
        }
      }
    };

    // 次へボタン押下
    const nextCurrent = () => {
      if(state.baseSheet.page_count > state.currentSheetActivity.page){
        changeCurrent(state.currentExamineeIdx, state.currentSheetActivityIdx + 1);
      }else{
        for(var i = state.currentExamineeIdx + 1; i < state.examinees.length; i++){
          if(state.examinees[i].sheetActivities != null && state.examinees[i].sheetActivities.length > 0){
            changeCurrent(i, 0);
            break;
          }
        }
      }
    };

    // 左回転ボタン押下
    const rotateLeft = async() => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.currentSheetActivity.angle - 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    // 右回転ボタン押下
    const rotateRight = async () => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.currentSheetActivity.angle + 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    // 回転保存ボタン押下
    const rotateSave = async (isConfirmMsg: boolean = true, isResutMsg: boolean = true) => {
      
      if(state.currentSheetActivity.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_activity_id: state.currentSheetActivity.id,
        angle: state.currentSheetActivity.angle,
        page: state.currentSheetActivityIdx + 1,
        student_code: state.currentExaminee.student_code
      };

      await http.post(`/api/sheet_upload/rotate/${state.sheet_id}`, param).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        state.currentSheetActivity.base64Image = response.data.base64_image;
        state.currentSheetActivity.baseWidth = response.data.image_size_hash.width;
        state.currentSheetActivity.baseHeight = response.data.image_size_hash.height;
        state.currentSheetActivity.angle = 0;
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }

        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 一括回転
    const rotateAll = async (angle: number) => {

      if(!window.confirm(`${state.currentSheetActivity.page}ページ目の一括回転を実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_id: state.sheet_id,
        sheet_activity_id: state.currentSheetActivity.id,
        angle: angle,
        page: state.currentSheetActivityIdx + 1,
      };

      await http.post(`/api/sheet_upload/rotate_all/${state.sheet_id}`, param).then(response => {

        // キャッシュ済みの答案画像をクリア
        state.examinees.forEach((e: Examinee) => {
          e.sheetActivities.forEach((s: SheetActivity) => {
            s.base64Image = null;
            s.baseWidth = 0;
            s.baseHeight = 0;
          });
        });

        state.currentSheetActivity.base64Image = response.data.base64_image;
        state.currentSheetActivity.baseWidth = response.data.image_size_hash.width;
        state.currentSheetActivity.baseHeight = response.data.image_size_hash.height;
        state.currentSheetActivity.angle = 0;

        alert("処理が完了しました。");
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }

        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 欠席者モーダル表示
    const showAbsentModal = (file: any) => {
      state.file = file[0];
      modalSheetUploadRef.value.show();
    };

    // アップロードモーダル閉じる
    const closeSheetUploadModal = () => {
      modalSheetUploadRef.value.hide();
      state.examinees.forEach((x: Examinee) => {
        x.isSelected = false;
      });
    };

    // 答案アップロード
    const upload = async () => {

      modalSheetUploadRef.value.hide();

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }
      
      // 登録対象の出席番号リスト取得
      const studentNos = state.examinees.filter((x: Examinee) => x.isSelected).map((x: Examinee) => x.student_no);
      const studentCodes = state.examinees.filter((x: Examinee) => x.isSelected).map((x: Examinee) => x.student_code);
      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', state.file);
      fd.append('student_codes', JSON.stringify(studentCodes));

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/sheet_upload/upload/${state.sheet_id}/${studentNos}`, fd).then(response => {
        state.examinees = response.data.sheet.examinees.map((x: any) => new Examinee(x, response.data.sheet.sheet_activities));
        changeCurrent(0, 0);
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      state.examinees.forEach((x: Examinee) => {
        x.isSelected = false;
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 答案削除ボタン押下
    const destroy = async (examinee: Examinee) => {
      if(!window.confirm(`生徒CD${examinee.student_code}の答案を削除します。よろしいですか？`)){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/sheet_upload/destroy/${state.sheet_id}/${examinee.student_no}`).then(response => {
        
        // 削除した結果生徒数0名になった場合は一覧に戻る
        if(response.data.is_sheet_deleted){
          alert("受験生徒が0名になりました。試験一覧に戻ります。");
          window.history.back();
          return;
        }

        const idx = state.examinees.indexOf(examinee);
        state.examinees.splice(idx, 1);

        changeCurrent(0, 0);

        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 一括削除ボタン押下
    const destroyAll = async () => {

      if(state.examinees.length == 0){
        alert("削除対象が存在しません。");
        return;
      }

      if(!window.confirm("答案を一括削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/sheet_upload/destroy_all/${state.sheet_id}`).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 切り出しボタン押下
    const imageCut = async () => {

      if(!window.confirm("切り出しを実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/sheet_upload/create_cut_job/${state.sheet_id}`).then(response => {
        alert("答案切り出しを開始しました");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    // keyUpイベント
    const keyUp = (e: KeyboardEvent): void => {

      if (e.key == "ArrowDown") {
        e.preventDefault();

        for(var i = state.currentExamineeIdx + 1; i < state.examinees.length; i++){
          if(state.examinees[i].sheetActivities != null && state.examinees[i].sheetActivities.length > 0){
            changeCurrent(i, state.currentSheetActivityIdx);
            break;
          }
        }
        return;
      }

      if (e.key == "ArrowUp") {
        e.preventDefault();

        for(var i = state.currentExamineeIdx - 1; i >= 0; i--){
          if(state.examinees[i].sheetActivities != null && state.examinees[i].sheetActivities.length > 0){
            changeCurrent(i, state.currentSheetActivityIdx);
            break;
          }
        }

        return;
      }

      if (e.key == "ArrowLeft") {
        e.preventDefault();

        if (state.currentSheetActivity.page > 1) {
          changeCurrent(state.currentExamineeIdx, state.currentSheetActivityIdx - 1);
        }

        return;
      }
      
      if (e.key == "ArrowRight") {
        e.preventDefault();
        
        if (state.currentSheetActivity.page < state.baseSheet.page_count) {
          changeCurrent(state.currentExamineeIdx, state.currentSheetActivityIdx + 1);
        }

        return;
      }
    }

    /******************************
     * created
     ******************************/
    
    const created = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;

      await http.get(`/api/sheet_upload?sheet_id=${state.sheet_id}`).then(response => {        
        state.score_positions_completed = response.data.base_sheet.score_positions_completed;
        state.baseSheet = new BaseSheet(response.data.base_sheet);
        state.sheet = new Sheet(response.data.sheet);
        state.examinees = response.data.sheet.examinees.map((x: any) => new Examinee(x, response.data.sheet.sheet_activities));
        if(state.examinees.length > 0){
          changeCurrent(0, 0);
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keyup", keyUp);
      context.root.$store.dispatch("hideOverlay");
    }

    created();

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalSheetUploadRef,
      imageStyle,
      imageWrapStyle,
      changeCurrent,
      scaleUp,
      scaleDown,
      adjustWidth,
      adjustHeight,
      prevCurrent,
      nextCurrent,
      rotateLeft,
      rotateRight,
      rotateSave,
      rotateAll,
      closeSheetUploadModal,
      showAbsentModal,
      upload,
      destroyAll,
      destroy,
      imageCut,
     };
  }
})
